module.exports = __webpack_public_path__ + "img/star-of-david.d6e32944.svg";